import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	emptyStateHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyStateDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	add: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	emptyStateHeading: {
		id: 'software-releases-version-related-work.empty-state.empty-state-heading',
		defaultMessage: 'Start adding some related work',
		description: 'Title of a section that tells the user how to add links to their versions.',
	},
	emptyStateDescription: {
		id: 'software-releases-version-related-work.empty-state.empty-state-description',
		defaultMessage:
			"Add the work that's needed to get ready for your release like designs, release notes, analytics dashboards, and more!",
		description: 'Message that explains why the user would want to add links to their version.',
	},
	add: {
		id: 'software-releases-version-related-work.empty-state.add',
		defaultMessage: 'Add related work',
		description:
			'Shown on a button that allows the user to add an associated link to their version.',
	},
});
export default messages;
